import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const E_P_P_S_T = ({ setEdit }) => {
  const data = [
    {
      date: "01 JAN 2025",
      vendorName: "ULTIMATE ANALYTICS PVT. LTD",
      address:
        "North Sales Office, 1009 Express Apartment Sector 4, Vaishli, Ghaziabad, Delhi NCR – 201010",
      contactPerson: "Mr. Arka",
      contactNo: "9876543210",
      serviceUsed: "Lab Equipment's Procurement",
      performance: "Satisfactory",
      remarks: "No Remark",
    },
    {
      date: "01 JAN 2025",
      vendorName: "KOLOSH INSTRUMENTS",
      address: "Ashokgarh, Dunlop, Kolkata, Kolkata, West Bengal, 700035",
      contactPerson: "Mr. Sahid",
      contactNo: "9988776655",
      serviceUsed: "PT Provider",
      performance: "Satisfactory",
      remarks: "No Remark",
    },
    {
      date: "01 JAN 2025",
      vendorName: "KOLOSH INSTRUMENTS",
      address:
        "Global PT Provider E-44/12, Okhla Industrial Area, Phase-II, New Delhi - 110020",
      contactPerson: "Mrs. Sathe",
      contactNo: "9988776655",
      serviceUsed: "Lab Equipment's Procurement",
      performance: "Satisfactory",
      remarks: "No Remark",
    },
    {
      date: "01 JAN 2025",
      vendorName: "KOLOSH INSTRUMENTS",
      address:
        "Global PT Provider E-44/12, Okhla Industrial Area, Phase-II, New Delhi - 110020",
      contactPerson: "Mrs. Sathe",
      contactNo: "9988776655",
      serviceUsed: "Lab Equipment's Procurement",
      performance: "Satisfactory",
      remarks: "No Remark",
    },
    {
      date: "01 JAN 2025",
      vendorName: "KOLOSH INSTRUMENTS",
      address:
        "Global PT Provider E-44/12, Okhla Industrial Area, Phase-II, New Delhi - 110020",
      contactPerson: "Mrs. Sathe",
      contactNo: "9988776655",
      serviceUsed: "Lab Equipment's Procurement",
      performance: "Satisfactory",
      remarks: "No Remark",
    },
    {
      date: "01 JAN 2025",
      vendorName: "KOLOSH INSTRUMENTS",
      address:
        "Global PT Provider E-44/12, Okhla Industrial Area, Phase-II, New Delhi - 110020",
      contactPerson: "Mrs. Sathe",
      contactNo: "9988776655",
      serviceUsed: "Lab Equipment's Procurement",
      performance: "Satisfactory",
      remarks: "No Remark",
    },
    {
      date: "01 JAN 2025",
      vendorName: "KOLOSH INSTRUMENTS",
      address:
        "Global PT Provider E-44/12, Okhla Industrial Area, Phase-II, New Delhi - 110020",
      contactPerson: "Mrs. Sathe",
      contactNo: "9988776655",
      serviceUsed: "Lab Equipment's Procurement",
      performance: "Satisfactory",
      remarks: "No Remark",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              {" "}
              <tr>
                {" "}
                <th>
                  {" "}
                  <input type="checkbox" />{" "}
                </th>{" "}
                <th>Date</th> <th>Name Of Vendor</th> <th>Address</th>{" "}
                <th>Contact Person</th> <th>Contact No.</th>{" "}
                <th>Service Used</th> <th>Performance</th> <th>Remarks</th>{" "}
              </tr>{" "}
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.vendorName}</td>
                  <td>{row.address}</td>
                  <td>{row.contactPerson}</td>
                  <td>{row.contactNo}</td>
                  <td>{row.serviceUsed}</td>
                  <td>{row.performance}</td>
                  <td>{row.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default E_P_P_S_T;
